module.exports = __webpack_public_path__ + "static/img/reg-bg-left.a772a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reg-bg-left.jpg
// module id = 947
// module chunks = 1